import React, { useEffect, useState } from 'react';
import axiosInstance from '../../axiosConfig';
import UserTemplatePage from './UserTemplatePage';
import '../../styles/UserResumePage.css';
import ResumeSkeleton from '../Loading/ResumeSkeleton';

const UserResumePage = () => {
    const [userTemplate, setUserTemplate] = useState(null);
    const [templateName, setTemplateName] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchUserTemplate = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get('/api/userTemplates/current');

                setLoading(false);

                if (response.data) {
                    setUserTemplate(response.data);
                    setTemplateName(response.data.name);
                } else {
                    // Handle error state or redirect as needed
                }
            } catch (error) {
                setLoading(false);
                // Handle error state or redirect as needed
            }
        };

        fetchUserTemplate();
    }, []);

    return (
        <div className="resume-page-container">
            {loading ? (
                <div className="loader-container">
                    <ResumeSkeleton />
                </div>
            ) : (
                userTemplate ? (
                    <UserTemplatePage template={userTemplate} name={templateName} />
                ) : (
                    <p>No resume available.</p>
                )
            )}
        </div>
    );
};

export default UserResumePage;
